
export const dashboardMain = {
  namespaced: true,
  state: {
    processConfirmationSearch: null,
    processAcceptedSearch: null,
    processUnassignedSearch: null,
    userConfirmationSearch: null,
    userRoleInvitationSearch: null,
  },
  mutations: {
    storeProcessConfirmationSearch(state, search) {
      state.processConfirmationSearch = search;      
    },
    storeProcessAcceptedSearch(state, search) {
      state.processAcceptedSearch = search;     
    },
    storeProcessUnassignedSearch(state, search) {
      state.processUnassignedSearch = search;      
    },
    storeUserConfirmationSearch(state, search) {
      state.userConfirmationSearch = search;    
    },
    storeUserRoleInvitationSearch(state, search) {
      state.userRoleInvitationSearch = search;     
    }
  }
}
